import { CaseInfoBannerKey, CaseLandingViewProps } from "src/pages/case-landing/case-landing-view-model";
import { PortalState } from "src/api/types/enums";

export function useCaseInAssessmentViewProps(state: PortalState): CaseLandingViewProps {
  switch (state) {
    case PortalState.NoRedressAssessment: {
      return {
        bannerKey: CaseInfoBannerKey.CaseOnHold,
      };
    }
    case PortalState.ChallengeSubmitted: {
      return {
        bannerKey: CaseInfoBannerKey.ObjectionReview,
      };
    }
    default:
      return {
        bannerKey: CaseInfoBannerKey.CaseOnHold,
      };
  }
}
